function convertCubicFootToCubicInch(num) {
  let eq =
    "Converting " +
    num +
    " cubic foot to cubic inch: \n" +
    num +
    " * 1728 = ";
  let rep = num * 1728;
  return eq + rep.toFixed(2);
}

function convertCubicFootToLiter(num) {
  let eq =
    "Converting " +
    num +
    " cubic foot to liter: \n" +
    " * 28.31684659 = ";
  let rep = num * 28.31684659;
  return eq + rep.toFixed(3);
}

function convertCubicFootToCubicYard(num) {
  let eq =
    "Converting " +
    num +
    " cubic foot to cubic yard: \n" +
    num +
    " * 0.03703703704 = ";
  let rep = num * 0.03703703704;
  return eq + rep.toFixed(4);
}

function convertCubicFootToCubicMile(num) {
  let eq =
    "Converting " +
    num +
    " cubic foot to cubic mile: \n" +
    num +
    " * 6.7935733132574E-12 = ";
  let rep = num * 6.7935733132574E-12;
  return eq + rep.toFixed(12);
}

function convertCubicFootToCubicMeter(num) {
  let eq =
    "Converting " +
    num +
    " cubic foot to cubic meter: \n" +
    num +
    " * 0.02831684659  = ";
  let rep = num * 0.02831684659 ;
  return eq + rep.toFixed(4);
}

export {
  convertCubicFootToCubicInch,
  convertCubicFootToCubicMeter,
  convertCubicFootToCubicMile,
  convertCubicFootToCubicYard,
  convertCubicFootToLiter
};
